"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yapiPostData = exports.default = exports.apigetrightsgetorder = exports.apigetrightscheck = exports.apigetreverseGeocode = exports.apigetiplocate = exports.apigetgeocode = exports.apigetWechatCustomerService = exports.apiSaveMerchantInfo = exports.apiSaveApply = exports.apiPutData = exports.apiPostData = exports.apiMallDetail = exports.apiGetpcammdetail = exports.apiGetpcamm = exports.apiGetpcRecommend = exports.apiGetammfullsearch = exports.apiGetUserInfo = exports.apiGetTgData = exports.apiGetSpecialMessage = exports.apiGetRewordPrice = exports.apiGetResolving = exports.apiGetReg = exports.apiGetRapidReleaseBusiness = exports.apiGetRapidRelease = exports.apiGetPubGoodsData = exports.apiGetPubCarsData = exports.apiGetPopularRecommend = exports.apiGetPlateclassify = exports.apiGetPlateClassifyData = exports.apiGetPcByCmmid = exports.apiGetPageMerchantInfoList = exports.apiGetNewsUrlJump = exports.apiGetMsdsDescByKeyword = exports.apiGetLogin = exports.apiGetLandingPageClick = exports.apiGetLandingPage = exports.apiGetForgetPassword = exports.apiGetDataStatisticsPc = exports.apiGetDataCount = exports.apiGetData = exports.apiGetColunm = exports.apiGetCode = exports.apiGetBusinessCooperation = exports.apiGetBusinessCardInformation = exports.apiGetArticleFabulous = exports.apiGetArticleChick = exports.apiGetAdvertiseData = exports.apiDeleteData = exports.apiCaptcha = exports.apiArticlSearch = void 0;
var _defineProperty2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _axios = _interopRequireDefault(require("axios"));
var _qs = _interopRequireDefault(require("qs"));
var _main = _interopRequireDefault(require("../main"));
var _elementUi = require("element-ui");
var _cookie = require("@/assets/static/js/utils/cookie.js");
_axios.default.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.headers.common["token"] = window.sessionStorage.getItem('user')?JSON.parse(window.sessionStorage.getItem('user')).token:''

//http request 拦截器
_axios.default.interceptors.request.use(function (config) {
  if (config.url.indexOf('vctapp') != -1) {
    config.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
  } else {
    config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
    config.data = _qs.default.stringify(config.data);
  }

  // session替换成cookie
  config.headers.common["token"] = (0, _cookie.getCookie)('user') ? JSON.parse((0, _cookie.getCookie)('user')).token : '';
  return config;
}, function (error) {
  return Promise.reject(error);
});

//http response 拦截器
_axios.default.interceptors.response.use(function (response) {
  if (response.data.proCode == 5017) {
    // session替换成cookie
    (0, _cookie.delCookie)('token');
    (0, _cookie.delCookie)('user');
    _main.default.$data.isLogin = false;
    _main.default.$data.dialogFormVisible = true;
    // Message({
    //     message: 'token过期请重新登录!',
    //     type: 'error'
    // });
  }
  console.log(response);
  return response;
}, function (error) {
  return Promise.reject(error);
});
var hanleResponse = function hanleResponse(_ref) {
  var status = _ref.status,
    data = _ref.data;
  var success = true;
  console.log('resp', data);
  if (status != '200') {
    success = false;
    (0, _elementUi.Message)({
      message: "网络异常,请求失败!",
      type: 'error'
    });
    return {
      success: success,
      data: data
    };
  }
  // 针对code/proCode=250的敏感词提示
  if (data.code && data.code == '250' || data.proCode && data.proCode == '250') {
    success = false;
    (0, _elementUi.Message)({
      message: data.proMsg || data.msg,
      type: 'error'
    });
    return {
      success: success,
      data: data
    };
  }
  if (data.code && data.code != '200') {
    success = false;
    (0, _elementUi.Message)({
      message: data.msg,
      type: 'error'
    });
    return {
      success: success,
      data: data
    };
  }
  if (data.proCode && data.proCode != '200') {
    success = false;
    (0, _elementUi.Message)({
      message: data.proMsg,
      type: 'error'
    });
    return {
      success: success,
      data: data
    };
  }
  return {
    success: success,
    data: data
  };
};

// yapi格式post请求
var yapiPostData = exports.yapiPostData = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, fun) {
    var params,
      version,
      yapiParams,
      _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          params = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          version = _args.length > 3 && _args[3] !== undefined ? _args[3] : 2;
          yapiParams = {
            jsonParamete: {
              version: version,
              fun: fun,
              param: Object.assign(params)
            }
          };
          console.log('yapiparamas:', JSON.stringify(yapiParams));
          _context.t0 = hanleResponse;
          _context.next = 7;
          return _axios.default.post(url, yapiParams);
        case 7:
          _context.t1 = _context.sent;
          return _context.abrupt("return", (0, _context.t0)(_context.t1));
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function yapiPostData(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
var apiGetData = exports.apiGetData = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url) {
    var params,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          params = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          _context2.t0 = hanleResponse;
          _context2.next = 4;
          return _axios.default.get(url, {
            params: params
          });
        case 4:
          _context2.t1 = _context2.sent;
          return _context2.abrupt("return", (0, _context2.t0)(_context2.t1));
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function apiGetData(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
var apiPostData = exports.apiPostData = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url) {
    var params,
      _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          params = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
          _context3.t0 = hanleResponse;
          _context3.next = 4;
          return _axios.default.post(url, params);
        case 4:
          _context3.t1 = _context3.sent;
          return _context3.abrupt("return", (0, _context3.t0)(_context3.t1));
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function apiPostData(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
var apiPutData = exports.apiPutData = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(url) {
    var params,
      _args4 = arguments;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          params = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
          _context4.t0 = hanleResponse;
          _context4.next = 4;
          return _axios.default.put(url, params);
        case 4:
          _context4.t1 = _context4.sent;
          return _context4.abrupt("return", (0, _context4.t0)(_context4.t1));
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function apiPutData(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
var apiDeleteData = exports.apiDeleteData = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(url) {
    var params,
      _args5 = arguments;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          params = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
          _context5.t0 = hanleResponse;
          _context5.next = 4;
          return _axios.default.delete(url, {
            params: params
          });
        case 4:
          _context5.t1 = _context5.sent;
          return _context5.abrupt("return", (0, _context5.t0)(_context5.t1));
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function apiDeleteData(_x6) {
    return _ref6.apply(this, arguments);
  };
}();

// 数据统计 
var apiGetDataCount = exports.apiGetDataCount = function apiGetDataCount(params) {
  return apiPostData('/vescort/oc/ocshareaction/findocsharetotal', params);
};

//发布车源
var apiGetPubCarsData = exports.apiGetPubCarsData = function apiGetPubCarsData(params) {
  return (0, _axios.default)({
    url: '/vescort/tra/vehiclesourceaction/releasepcvs',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      // session替换成cookie
      'token': (0, _cookie.getCookie)('user') ? JSON.parse((0, _cookie.getCookie)('user')).token : ''
    },
    params: params
  }).then(function (res) {
    //  console.info(res)
    return res;
  }).catch(function (e) {
    //  console.info(e)
    return e;
  });
};

//发布货源
var apiGetPubGoodsData = exports.apiGetPubGoodsData = function apiGetPubGoodsData(params) {
  return (0, _axios.default)({
    url: '/vescort/tra/goodssourceaction/releasepcgs',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      // session替换成cookie
      'token': (0, _cookie.getCookie)('user') ? JSON.parse((0, _cookie.getCookie)('user')).token : ''
    },
    params: params
  }).then(function (res) {
    //  console.info(res)
    return res;
  }).catch(function (e) {
    //  console.info(e)
    return e;
  });
};

// 登录
var apiGetLogin = exports.apiGetLogin = function apiGetLogin(params) {
  return apiPostData('/vescort/app/login/login.app', params);
};

// 验证码
// export const apiGetCode = (params) => { return apiPostData('/vescort/app/login/sendVerificationCode.app', params) }
var apiGetCode = exports.apiGetCode = function apiGetCode(params) {
  return yapiPostData('/vctapp/verify/sendVerificationCode', 'sendVerificationCode', params);
};

//忘记密码
var apiGetForgetPassword = exports.apiGetForgetPassword = function apiGetForgetPassword(params) {
  return apiPostData('/vescort/app/login/forgetPassword.app', params);
};

// 注册
var apiGetReg = exports.apiGetReg = function apiGetReg(params) {
  return apiPostData('/vescort/app/login/verificationcodelogin.app', params);
};

// 获取栏目
var apiGetColunm = exports.apiGetColunm = function apiGetColunm(params) {
  return apiPostData('/vescort/cms/colunmmanagementmainaction/findcolunm', params);
};

// 获取热门推荐栏目资讯列表
var apiGetPopularRecommend = exports.apiGetPopularRecommend = function apiGetPopularRecommend(params) {
  return apiPostData('/vescort/cms/articlemanagementmainaction/findpopularrecommend', params);
};

// 获取其他栏目资讯列表
var apiGetPcByCmmid = exports.apiGetPcByCmmid = function apiGetPcByCmmid(params) {
  return apiPostData('/vescort/cms/articlemanagementmainaction/findpcbycmmid', params);
};

// 获取最新资讯列表
var apiGetpcamm = exports.apiGetpcamm = function apiGetpcamm(params) {
  return apiPostData('/vescort/cms/articlemanagementmainaction/findpcamm', params);
};

// 获取搜索列表
var apiGetammfullsearch = exports.apiGetammfullsearch = function apiGetammfullsearch(params) {
  return apiPostData('/vescort/cms/articlemanagementmainaction/ammfullsearch', params);
};

// 获取资讯详情
var apiGetpcammdetail = exports.apiGetpcammdetail = function apiGetpcammdetail(params) {
  return apiPostData('/vescort/cms/articlemanagementmainaction/findpcammdetail', params);
};

// 资讯文章查看数增加
var apiGetArticleChick = exports.apiGetArticleChick = function apiGetArticleChick(params) {
  return apiPostData('/vescort/cms/articlechickrelationaction/articlechick', params);
};

// 资讯文章点赞数增加
var apiGetArticleFabulous = exports.apiGetArticleFabulous = function apiGetArticleFabulous(params) {
  return apiPostData('/vescort/cms/articlefabulousrelationaction/articlefabulous', params);
};

// 获取资讯文章相关推荐列表
var apiGetpcRecommend = exports.apiGetpcRecommend = function apiGetpcRecommend(params) {
  return apiPostData('/vescort/cms/articlemanagementmainaction/findpcrecommend', params);
};

//请求推广码和url
var apiGetTgData = exports.apiGetTgData = function apiGetTgData(params) {
  return apiPostData('/getUserImg.dhtml', params);
};

// 获取数据字典
var apiGetDicData = function apiGetDicData(params) {
  return apiPostData('/vescort/sys/dictAction/finddictdata', params);
};

// 获取货源列表
// const apiGetGoodsData = (params) => { return apiPostData('/vescort/tra/goodssourceaction/findpcgs', params) }
// 获取货源列表（新）
var apiGetGoodsData = function apiGetGoodsData(params) {
  return yapiPostData('/vctapp/pcGoodsSource/pcGshall', 'pcGshall', params);
};

// 获取车源列表
var apiGetCarsData = function apiGetCarsData(params) {
  return apiPostData('/vescort/tra/vehiclesourceaction/findpcvs', params);
};

// 获取货物类型
var apiGetGoodsTypeData = function apiGetGoodsTypeData(params) {
  return apiPostData('/vescort/basedata/apiaction/findpcgoodstype', params);
};

// 获取车辆类型
var apiGetCarTypeData = function apiGetCarTypeData(params) {
  return apiPostData('/vescort/basedata/apiaction/getvehicletype', params);
};

// 获取所有行政区编码
var apiGetAreaData = function apiGetAreaData(params) {
  return apiPostData('/vescort/basedata/apiaction/getallarearepository', params);
};

// 获取货源详情
var apiGetGoodsDetailData = function apiGetGoodsDetailData(params) {
  return apiPostData('/vescort/tra/goodssourceaction/pcgsdetail', params);
};

// 获取车源详情
var apiGetCarsDetailData = function apiGetCarsDetailData(params) {
  return apiPostData('/vescort/tra/vehiclesourceaction/pcvsdetail', params);
};

// 根据货源ID推荐货源
var apiGetRecGoodsBygsidData = function apiGetRecGoodsBygsidData(params) {
  return apiPostData('/vescort/tra/goodssourceaction/pcrmdgsbygsid', params);
};

// 根据车源ID推荐车源
var apiGetRecCarsByvsisData = function apiGetRecCarsByvsisData(params) {
  return apiPostData('/vescort/tra/vehiclesourceaction/pcrmdvsbyvsid', params);
};

// 根据车源ID推荐货源
var apiGetRecGoodsByvsidData = function apiGetRecGoodsByvsidData(params) {
  return apiPostData('/vescort/tra/goodssourceaction/pcrmdgsbyvsid', params);
};

// 根据货源ID推荐车源
var apiGetRecCarsBygsisData = function apiGetRecCarsBygsisData(params) {
  return apiPostData('/vescort/tra/vehiclesourceaction/pcrmdvsbygsid', params);
};

// 车源询价
var apiGetAskPriceData = function apiGetAskPriceData(params) {
  return apiPostData('/vescort/tra/vehiclesourceaction/pcvsinquiry', params);
};

// 货源报价
var apiGetPushPriceData = function apiGetPushPriceData(params) {
  return apiPostData('/vescort/tra/goodssourceaction/pcgsquote', params);
};

// 发布货源
// export const apiGetPubGoodsData =  (params) => {return apiPostData('/vescort/tra/goodssourceaction/releasepcgs',params)}

// 发布车源
// export const apiGetPubCarsData =  (params) => {return apiPostData('/vescort/tra/vehiclesourceaction/releasepcvs',params)}

// 获取广告
var apiGetAdvertiseData = exports.apiGetAdvertiseData = function apiGetAdvertiseData(params) {
  return apiPostData('/vescort/cms/advertmanagementaction/findapcadvert', params);
};

// 注册落地页-获取模板
var apiGetLandingPage = exports.apiGetLandingPage = function apiGetLandingPage(params) {
  return apiPostData('/vescort/page/registerLandingPageAction/getLandingPage', params);
};

// 注册落地页-点击事件上报
var apiGetLandingPageClick = exports.apiGetLandingPageClick = function apiGetLandingPageClick(params) {
  return apiPostData('/vescort/page/registerLandingPageAction/landingPageClick', params);
};

// 招商合作-投标表单提交
var apiGetBusinessCooperation = exports.apiGetBusinessCooperation = function apiGetBusinessCooperation(params) {
  return apiPostData('/vescort/oc/businessCooperationAction/savebusinesscooperation', params);
};

// 批量发布-智能识别
var apiGetResolving = exports.apiGetResolving = function apiGetResolving(params) {
  return apiPostData('/app/config/resolving.app', params);
};

// 批量发布-登录发布
var apiGetRapidRelease = exports.apiGetRapidRelease = function apiGetRapidRelease(params) {
  return apiPostData('/app/goodsSource/rapidRelease.app', params);
};

// 批量发布-未登录发布
var apiGetRapidReleaseBusiness = exports.apiGetRapidReleaseBusiness = function apiGetRapidReleaseBusiness(params) {
  return apiPostData('/dac/business', params);
};

//镖局专车-获取预估价格
var apiGetRewordPrice = exports.apiGetRewordPrice = function apiGetRewordPrice(param) {
  return apiPostData('/vescort/vcar/specialCarGoodsAction/getGoodsPrepictCost', param);
};

//镖局专车-信息提交接口
var apiGetSpecialMessage = exports.apiGetSpecialMessage = function apiGetSpecialMessage(param) {
  return apiPostData('/vescort/vcar/specialCarGoodsAction/saveSpecialCarGoods', param);
};

// 根据token获取用户信息(手机号,姓名)
var apiGetUserInfo = exports.apiGetUserInfo = function apiGetUserInfo(params) {
  return apiPostData('/vescort/business/apiaction/getuserinfo', params);
};

// 根据token获取用户名片信息(手机号,姓名，公司名称)
var apiGetBusinessCardInformation = exports.apiGetBusinessCardInformation = function apiGetBusinessCardInformation(params) {
  return apiPostData('/vescort/vcar/specialCarGoodsAction/getBusinessCardInformation', params);
};

// 判断资讯内链接是否可跳转
var apiGetNewsUrlJump = exports.apiGetNewsUrlJump = function apiGetNewsUrlJump(params) {
  return apiPostData('/vescort/cms/articlemanagementmainaction/checkUrlJump', params);
};

// 查询MSDS列表
var apiGetMsdsDescByKeyword = exports.apiGetMsdsDescByKeyword = function apiGetMsdsDescByKeyword(params) {
  return apiPostData('/vescort/msds/msdsBusinessAction/getMsdsDescByKeyword', params);
};

// 危化商铺搜索
var apiGetPlateclassify = exports.apiGetPlateclassify = function apiGetPlateclassify(params) {
  return apiPostData('/vescort/bc/plateAction/getplateclassify', params);
};

// 危化商铺列表查询
var apiGetPageMerchantInfoList = exports.apiGetPageMerchantInfoList = function apiGetPageMerchantInfoList(params) {
  return apiPostData('/vescort/bc/searches/pageMerchantInfoList', params);
};

// 危化商铺板块分类查询
var apiGetPlateClassifyData = exports.apiGetPlateClassifyData = function apiGetPlateClassifyData(params) {
  return apiPostData('/vescort/bc/plateAction/getplateclassifybycode', params);
};

// 危化商铺保存信息
var apiSaveMerchantInfo = exports.apiSaveMerchantInfo = function apiSaveMerchantInfo(params) {
  return apiPostData('/vescort/bc/merchantInfoAction/saveMchInfo', params);
};

// 文章搜索
var apiArticlSearch = exports.apiArticlSearch = function apiArticlSearch(params) {
  return yapiPostData('/vctapp/article/articleSearch', 'articleSearch', params);
};

// 商铺列表详情
var apiMallDetail = exports.apiMallDetail = function apiMallDetail(params) {
  return apiPostData('/vescort/bc/merchantInfoAction/merchantdetail', params);
};

// 保存综合产品使用申请
var apiSaveApply = exports.apiSaveApply = function apiSaveApply(params) {
  return yapiPostData('/vctapp/ptProductUseApply/saveProductUseApply', 'saveProductUseApply', params);
};

// 商铺列表详情
var apiGetDataStatisticsPc = exports.apiGetDataStatisticsPc = function apiGetDataStatisticsPc(params) {
  return apiPostData('/vescort/basedata/apiaction/findDataStatisticsPc', params);
};

// 【撮合优化】根据区域及业务类型 查询所在区域企业客服信息
var apigetWechatCustomerService = exports.apigetWechatCustomerService = function apigetWechatCustomerService(params) {
  return yapiPostData('/vctapp/wechatCustomerServiceConfig/getWechatCustomerService', 'getWechatCustomerService', params);
};

//天地图正地理编码
var apigetgeocode = exports.apigetgeocode = function apigetgeocode(params) {
  return yapiPostData('/vctapp/app/tool/tianditu/geocode', 'geocode', params);
};

//天地图逆地理编码
var apigetreverseGeocode = exports.apigetreverseGeocode = function apigetreverseGeocode(params) {
  return yapiPostData('/vctapp/app/tool/tianditu/reverseGeocode', 'reverseGeocode', params);
};

//IP定位
var apigetiplocate = exports.apigetiplocate = function apigetiplocate(params) {
  return yapiPostData('/vctapp/app/tool/iplocate', 'iplocate', params);
};

//权益下单（除车货源订阅）
var apigetrightsgetorder = exports.apigetrightsgetorder = function apigetrightsgetorder(params) {
  return apiPostData('/vescort/rights/rightsApiAction/rightsgetorder', 'rightsgetorder', params);
};

//权益校验
var apigetrightscheck = exports.apigetrightscheck = function apigetrightscheck(params) {
  return apiPostData('/vescort/rights/rightsApiAction/rightscheck', params);
};

// 获取交互验证码
var apiCaptcha = exports.apiCaptcha = function apiCaptcha(params) {
  return yapiPostData('/vctapp/verify/getCaptcha', 'getCaptcha', params);
};
var _default = exports.default = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
  apiGetDicData: apiGetDicData,
  apiGetGoodsData: apiGetGoodsData,
  apiGetCarsData: apiGetCarsData,
  apiGetGoodsTypeData: apiGetGoodsTypeData,
  apiGetCarTypeData: apiGetCarTypeData,
  apiGetAreaData: apiGetAreaData,
  apiGetGoodsDetailData: apiGetGoodsDetailData,
  apiGetCarsDetailData: apiGetCarsDetailData,
  apiGetRecGoodsBygsidData: apiGetRecGoodsBygsidData,
  apiGetRecCarsByvsisData: apiGetRecCarsByvsisData,
  apiGetRecGoodsByvsidData: apiGetRecGoodsByvsidData,
  apiGetRecCarsBygsisData: apiGetRecCarsBygsisData,
  apiGetAskPriceData: apiGetAskPriceData,
  apiGetPushPriceData: apiGetPushPriceData,
  apiGetPubGoodsData: apiGetPubGoodsData,
  apiGetAdvertiseData: apiGetAdvertiseData,
  apiGetPlateclassify: apiGetPlateclassify,
  apiGetPageMerchantInfoList: apiGetPageMerchantInfoList,
  apiGetPlateClassifyData: apiGetPlateClassifyData,
  apiSaveMerchantInfo: apiSaveMerchantInfo,
  apiArticlSearch: apiArticlSearch,
  apigetWechatCustomerService: apigetWechatCustomerService,
  apigetgeocode: apigetgeocode,
  apigetreverseGeocode: apigetreverseGeocode,
  apigetiplocate: apigetiplocate
}, "apigetiplocate", apigetiplocate), "apigetrightscheck", apigetrightscheck), "apigetrightscheck", apigetrightscheck), "apiCaptcha", apiCaptcha), "apiGetForgetPassword", apiGetForgetPassword);